import { Outlet } from 'react-router-dom';
import { AccessibilityMenu } from '@semply/theme/AccessibilityMenu';
import { useEstSombre } from '@semply/theme/react';
import { BANNIERE } from '@semply/theme/sombre';
import { a11y, theme } from '../theme';
import { PortailNav } from './PortailNav';

interface Props {
  /**
   * Pages d'une personne connectée (01/11/2026) : barre d'onglets et colonne
   * large (960 px). Sans lui, la carte étroite des écrans de connexion.
   */
  connecte?: boolean;
}

export function AuthLayout({ connecte = false }: Props) {
  // Bannière de la suite (03/10/2026) : `banner-dark.svg` en sombre.
  const sombre = useEstSombre();
  return (
    <main className={connecte ? 'auth-shell auth-shell--large' : 'auth-shell'}>
      <div>
        <div className="brand">
          <img className="brand-logo" src={sombre ? BANNIERE.sombre : BANNIERE.clair} alt="SEmply" />
        </div>
        {connecte && <PortailNav />}
        <Outlet />
        {/* Sous la carte et non dedans : l'apparence et l'accessibilité sont
            des réglages du navigateur, pas une étape de la connexion. Le même
            menu que dans les produits de la suite (il remplace le seul
            sélecteur Clair/Sombre) ; il s'ouvre vers le haut, la commande
            étant en bas de page. */}
        <div className="auth-footer">
          <AccessibilityMenu theme={theme} a11y={a11y} className="a11y-menu-up" />
        </div>
      </div>
    </main>
  );
}
